import styled from 'styled-components';
import {mobileMedia} from '../../../../../../globalVariables/GlobalVariables';
import {getColor} from '../../../../utils/themeUtils';

export const header = styled.div`
    display: flex;
    width: 100%;
    ${mobileMedia}{
      display: none;
    }
`;

export const item = styled.div`
    width: 12%;
    text-align: center;
    color: ${p=>getColor(p.theme.isDarkMode)};

`;
export const ticketName = styled(item)`
    width: 30%;
    padding-inline-start: 30px;
`;
